<template>
  <lay-out class="c-f">
    <div class="mem-page-title">升级住逻辑会员</div>
    <div class="my-upgrade-container">
      <p>开通方式</p>
      <Row type="flex" class="m-t-20">
        <div
          class="vip-item cursor "
          v-for="(item,index) in tabs"
          :key="index"
          :class="{'active':activeIndex == index}"
          @click="handleChangeTab(index)"
        >
          {{item}}
          <div class="iconfont icon-wancheng-copy"></div>
        </div>
      </Row>
      <div class="desc">
        <div class="h-40">
          <Row type="flex" align="bottom" v-if="activeIndex == 0" >
            <div class="f-14">应付金额：</div>
            <div class="f-24 c-red lh-1 m-l-10">¥ 2499</div>
          </Row>
          <Row type="flex" align="bottom" v-if="activeIndex == 1" >
            <div class="f-14">所需恐龙蛋：</div>
            <div class="f-24 c-red lh-1 m-l-10">60000</div>
          </Row>
          <Row type="flex" align="middle" v-if="activeIndex == 2" >
            <div class="f-14">请输入兑换码</div>
            <div class="m-l-20">
              <Input v-model="exchangeCode" />
            </div>
          </Row>
        </div>
        <!-- <p class="m-t-30 f-w-500">
          购买即视为同意
          <a :href="`${baseUrl.baseOld}/help/questionDetail/egg-protocol`" target="_blank">《住逻辑会员服务协议》</a>
        </p> -->
        <p style="color:#707070;" class="m-t-30">住逻辑会员服务一经开通不支持取消/退款，敬请谅解。</p>
      </div>
      <div class="align-center ">
        <Button type="error" size="large" @click="handleUpgrade">立即升级</Button>
      </div>
    </div>
    <Modal v-model="visible" :width="dialogType === 6?'498px':'354px'" class="upgrade-dialog">
      <div class="upgrade-wd" v-show="dialogType === 1"><p>恭喜您升级为住逻辑会员</p><p>当前等级为V1</p></div>
      <div class="upgrade-wd" v-show="dialogType === 2"><p>亲，升级失败网络出错哦</p><p>请刷新页面看看</p></div>
      <div class="upgrade-wd" v-show="dialogType === 3"><p>对不起，您的恐龙蛋不足，无法升级</p></div>
      <div class="upgrade-wd" v-show="dialogType === 4"><p>请输入兑换码！</p></div>
      <div class="upgrade-wd" v-show="dialogType === 5"><p>输入的兑换码有误,请重新输入</p></div>
      <div class="upgrade-wd" v-show="dialogType === 6"><p style="font-size:16px;">确定用您账户中的 <span class="c-red">60000</span> 恐龙蛋兑换住逻辑会员嘛？</p></div>
      <div class="align-center p-t-10" v-show="dialogType === 1"><Button type="error" @click="goClub">前往会员俱乐部</Button></div>
      <div class="align-center p-t-30" v-show="dialogType === 6">
        <Button class="align-center" type="primary" @click="visible = false" style="width:170px;" >取消</Button>
        <Button type="error" class="m-l-10 align-center" @click="byEggPoing()" style="width:170px;">确定</Button>
      </div>
      <div slot="footer"></div>
    </Modal>
  </lay-out>
</template>

<script>
import axios from 'axios'
import LayOut from "../common/layout";


export default {
  components:{
    LayOut
  },
  data(){
    return {
      tabs:['按年付费','恐龙蛋抵扣','兑换码兑换'],
      activeIndex: 0,
      exchangeCode:'',
      VUE_APP_OLD_BASIC_URL: process.env.VUE_APP_OLD_BASIC_URL,
      visible:false,
      dialogType:1,  //1.成功  2.失败  3.恐龙蛋不足  4.请输入兑换码  5.兑换码错误  6.恐龙蛋兑换兑换
      baseUrl: {
        baseOld: process.env.VUE_APP_OLD_BASIC_URL,
        baseNext: process.env.VUE_APP_NEXT_BASIC_URL,
        baseNuxt: process.env.VUE_APP_NUXT_BASIC_URL
      },
    }
  },

  methods:{
    handleChangeTab(index){
      this.activeIndex = index
    },
    handleUpgrade(){
      if(this.activeIndex == 0){
        let params = {amount:2499,rechargeType:'member'}
        axios.post('/designer_api/points/points_member_recharge',params).then(res=> {
          let id = res.orderId;
          let url = `${this.VUE_APP_OLD_BASIC_URL}/my/pay/choicePay/${id}/4?display=1`
          window.location.href = url
        })
      }
      if(this.activeIndex == 1){
        let egg = this.$store.state.blance
        if(egg<60000){
          this.dialogType = 3
          this.visible = true
          return false
        }
        this.dialogType = 6
        this.visible = true
        // this.byEggPoing()
      }
      if(this.activeIndex ==2){
        if(!this.exchangeCode.trim()){
          // this.dialogType = 4
          // this.visible = true
          this.$Message.warning('请输入兑换码')
          return false
        }
        
        this.byExchangeCode()
      }
    },
    byExchangeCode(){
      
      axios.get(`/designer_api/user_invitations/codes/${this.exchangeCode}`).then(res => {
        if (res.result === false) {
            this.dialogType = 5
            this.visible = true
        }else{
            this.exchangeCode = '';
            this.dialogType = 1
            this.visible = true
        }
      },err => {
        this.dialogType = 2
          this.visible = true
      })
    },
    byEggPoing(){
      axios.put('/designer_api/points/consume_points_vip').then(res=>{
        this.dialogType = 1
        this.visible = true
      })
    },
    goClub(){
      window.location.href = `${this.baseUrl.baseOld}/my/personal/vip`
    }
  },
  mounted(){
    this.$store.dispatch('getBalance')
  }
}
</script>

<style lang="scss" scoped>
.my-upgrade-container {
  padding: 30px 30px 40px;
  .vip-item {
    width: 178px;
    height: 80px;
    background: #ffeded;
    border-radius: 4px;
    line-height: 80px;
    text-align: center;
    font-size: 18px;
    color: #313131;
    position: relative;
    .iconfont{
      position: absolute;
      top:8px;
      left:8px;
      font-size: 22px;
      line-height: 1;
      display: none;
    }
    &.active {
      // background-color: #313131;
      // color: #fff;
      .iconfont{
        display: block
      }
    }
    ~ .vip-item {
      margin-left: 20px;
    }
  }
  .desc {
    padding-top: 80px;
    padding-bottom: 150px;
    .h-40{
      height: 40px;
    }
  }
  .ivu-btn-large {
    height: 50px;
    width: 250px;
    span {
      font-size: 18px !important;
    }
  }
}
.upgrade-dialog{
 .upgrade-wd{
    padding-top:63px;
    text-align: center;
    p{
      line-height: 26px;
      margin-bottom: 20px;
      font-size: 18px;
      font-weight:500;
    }
  }
  .ivu-modal-footer{
    padding:0 !important;
    height:30px !important;
  }
}
</style>


